import { from } from 'apollo-link'
import error from './error'
import clean from './clean'
import http from './http'
import transformer from './transformer'
import notify from './notify'
import persist from './persist'
import debounce from './debounce'

const link =
  process.env.NODE_ENV !== 'development'
    ? from([debounce, clean, notify, error, transformer, persist(), http])
    : from([debounce, clean, notify, error, transformer, http])

export default link
